import { Skeleton } from '@/components/ui/skeleton';

/**
 * Loading skeleton for contract details modal content
 * Matches the structure of the actual modal content for smooth loading transitions
 */
export function ContractDetailsSkeleton() {
  return (
    <div className='space-y-6'>
      {/* Section header - matches the actual header styling */}
      <div className='mb-4 border-b border-border/50 pb-2'>
        <Skeleton className='h-6 w-48' />
      </div>

      {/* Two-column grid skeleton */}
      <div className='grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-4'>
        {/* Left column - Core cancellation details */}
        <div className='space-y-3'>
          {/* Cancel Status */}
          <div className='flex justify-between items-center'>
            <Skeleton className='h-4 w-20' />
            <Skeleton className='h-4 w-16' />
          </div>

          {/* Cancel Date */}
          <div className='flex justify-between items-center'>
            <Skeleton className='h-4 w-20' />
            <Skeleton className='h-4 w-20' />
          </div>

          {/* Cancel Mileage */}
          <div className='flex justify-between items-center'>
            <Skeleton className='h-4 w-24' />
            <Skeleton className='h-4 w-16' />
          </div>

          {/* Cancel Reason */}
          <div className='flex justify-between items-center'>
            <Skeleton className='h-4 w-20' />
            <Skeleton className='h-4 w-24' />
          </div>

          {/* Days Used */}
          <div className='flex justify-between items-center'>
            <Skeleton className='h-4 w-16' />
            <Skeleton className='h-4 w-12' />
          </div>

          {/* Miles Used */}
          <div className='flex justify-between items-center'>
            <Skeleton className='h-4 w-16' />
            <Skeleton className='h-4 w-12' />
          </div>

          {/* Contract Used */}
          <div className='flex justify-between items-center'>
            <Skeleton className='h-4 w-20' />
            <Skeleton className='h-4 w-12' />
          </div>
        </div>

        {/* Right column - Financial details */}
        <div className='space-y-3'>
          {/* Customer Refund Amount */}
          <div className='flex justify-between items-center'>
            <Skeleton className='h-4 w-24' />
            <Skeleton className='h-4 w-16' />
          </div>

          {/* Store Refund */}
          <div className='flex justify-between items-center'>
            <Skeleton className='h-4 w-24' />
            <Skeleton className='h-4 w-16' />
          </div>

          {/* Cancel Fee */}
          <div className='flex justify-between items-center'>
            <Skeleton className='h-4 w-20' />
            <Skeleton className='h-4 w-12' />
          </div>

          {/* Claims Deducted */}
          <div className='flex justify-between items-center'>
            <Skeleton className='h-4 w-28' />
            <Skeleton className='h-4 w-8' />
          </div>

          {/* Claims Amount (conditional, so shown as placeholder) */}
          <div className='flex justify-between items-center'>
            <Skeleton className='h-4 w-24' />
            <Skeleton className='h-4 w-14' />
          </div>
        </div>
      </div>
    </div>
  );
}
